import { apiRequest } from "@/utils/common/serviceApiHelper/serviceApiUtils";

import { ResponseGetSurvey } from "./surveyServiceInterface/surveyInterface";

export class SurveyServiceApi {
  private baseUrl: string;

  private basePath: string;

  constructor(baseUrl: string) {
    this.baseUrl = baseUrl;
    this.basePath = "v2/account/Survey";
  }

  async getSurvey() {
    try {
      const response = (await apiRequest(
        this.baseUrl,
        `${this.basePath}`,
        "GET",
      )) as any;
      return new ResponseGetSurvey(response);
    } catch {
      return null;
    }
  }

  async sendSurvey(params: any) {
    try {
      const response = (await apiRequest(
        this.baseUrl,
        `${this.basePath}`,
        "POST",
        params,
      )) as any;
      return {
        status: response.status,
        message: response.message,
      };
    } catch {
      return null;
    }
  }
}
